import { tratarMensagemDeErro } from "../helper";

const INITIAL_STATE = {
  alerta: {},
  cep: '',
  uf:null,
  municipio:null,
  municipios: [],
  disponibilidades: [],
  esperandoSolicitacao: false,
  urlSabi: ''
};

export default (state = INITIAL_STATE, action) => {

  switch (action.type) {
    case 'REQUERIMENTO_DISPONIBILIDADE_SET_CEP':
      return { ...state, cep: action.payload }
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARCEP_INICIO':
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARPERICIA_INICIO':
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARUNIDADE_INICIO':
      return { ...state, alerta: {}, esperandoSolicitacao: true }
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARCEP_SUCESSO':
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARMUNICIPIO_SUCESSO':
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARUNIDADE_SUCESSO':
      return { ...state, esperandoSolicitacao: false, disponibilidades: action.payload }
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARCEP_ERROR':
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARMUNICIPIO_ERROR':
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARUNIDADE_ERROR':
      return {
        ...state, esperandoSolicitacao: false, alerta: { message: tratarMensagemDeErro(action.payload), severity: 'error' }
      }
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARLOCALIZACAO_SUCESSO':
      return { ...state, esperandoSolicitacao: false, disponibilidades: action.payload, retornoLocalizacao: true }
    case 'REQUERIMENTO_DISPONIBILIDADE_BUSCARLOCALIZACAO_ERROR':
      return {
        ...state, esperandoSolicitacao: false, alerta: { message: tratarMensagemDeErro(action.payload), severity: "error" }, retornoLocalizacao: false };
    case 'REQUERIMENTO_DISPONIBILIDADE_UFS_RECEBIDOS':
      return { ...state, ufs: action.payload, esperandoSolicitacao: false }
    case 'REQUERIMENTO_DISPONIBILIDADE_MUNICIPIOS_RECEBIDOS':
      return { ...state, municipios: action.payload, esperandoSolicitacao: false }
    case 'REQUERIMENTO_PERICIA_DISPONIBILIDADE_AGENDA_PERICIA_SUCESSO': {
      return { ...state, esperandoSolicitacao: false, urlSabi: action.payload.url };
    }
    case 'REQUERIMENTO_PERICIA_DISPONIBILIDADE_AGENDA_PERICIA_ERRO': {
      return { ...state, esperandoSolicitacao: false };
    }
    case 'REQUERIMENTO_DISPONIBILIDADE_CLOSE_MESSAGE':
      return { ...state, alerta: {} }
    case 'REQUERIMENTO_DISPONIBILIDADE_SET_ALERT':
      return { ...state, alerta: action.payload }
    case 'REQUERIMENTO_DISPONIBILIDADE_SET_UF':
      return { ...state, uf: action.payload }
    case 'REQUERIMENTO_DISPONIBILIDADE_SET_MUNICIPIO':
      return { ...state, municipio: action.payload }
    default:
      return { ...state }
  }
}
